var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApplySuccess = function SvgApplySuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#EAF8EC",
    rx: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2FBC44",
    fillRule: "evenodd",
    d: "M30.81 27.222A13 13 0 0 0 33 20 13.014 13.014 0 0 0 20 7a13 13 0 1 0 10.81 20.222m-5.102-10.93a1 1 0 0 1 0 1.416l-7 7a1 1 0 0 1-1.415 0l-3-3a1 1 0 1 1 1.415-1.415L18 22.586l6.293-6.293a1 1 0 0 1 1.415 0",
    clipRule: "evenodd"
  })));
};
export default SvgApplySuccess;